// Set symbol URLs. `download_set_symbols` (functions/set_symbols.py) copies
// every Scryfall set icon into Cloud Storage at `set-symbols/<code>.svg` each
// night, so a symbol's URL follows from its set code alone: no lookup, and no
// request before the SVG itself. The bucket answers with
// `Access-Control-Allow-Origin: *`, which a CSS mask (shared/SetSymbol) needs.
// A set Scryfall has no icon for is a 404 and draws nothing.

import { FIREBASE_STORAGE_BUCKET } from '../logic/config.js';

const SET_SYMBOL_BASE = `https://firebasestorage.googleapis.com/v0/b/${FIREBASE_STORAGE_BUCKET}/o/set-symbols%2F`;

/**
 * The URL of a set's symbol SVG.
 * @param {string | null | undefined} setCode - The set code (e.g. 'mid', 'NEO')
 * @returns {string | null} - null for no set
 */
export function setSymbolUrl(setCode) {
  if (!setCode) return null;
  return `${SET_SYMBOL_BASE}${encodeURIComponent(setCode.toLowerCase())}.svg?alt=media`;
}
